<template>
    <div>
        <div class="cover-container d-flex w-100 h-100 p-3 pt-5 mx-auto flex-column">
            <div class="inner cover text-center">
                <h1>{{$ml.get('PLEASE_WAIT')}}</h1>
                <div class="lead" v-html="$ml.get('RECOVERY_INPROGRESS_MSG')"></div>
                <img src="static/images/loading.gif" class="img-fluid"/>
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
export default {
    name:"recoeryInprogress",
    data() {
        return {
            check:''
        }
    },
    methods: {
        ...mapActions(['getNotifications']),
        getNotificationsF(){
            var form = {}
            form.blockLoadingBar=true
            this.getNotifications(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log('getNotifications then response')
                console.log(res)
                if(res.status.code=='0'){
                    this.$router.push('/deals')
                    clearInterval(this.check)
                }
                
            })
        }
    },
    created() {
        var self = this
        this.check = setInterval(()=>{
            self.getNotificationsF()
        },5000)
    },
}
</script>